import { render, staticRenderFns } from "./ButtonWithIcon.vue?vue&type=template&id=69092856&scoped=true"
import script from "./ButtonWithIcon.ts?vue&type=script&lang=ts&external"
export * from "./ButtonWithIcon.ts?vue&type=script&lang=ts&external"
import style0 from "./ButtonWithIcon.scss?vue&type=style&index=0&id=69092856&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69092856",
  null
  
)

export default component.exports